import React from 'react';
import { createRoot } from 'react-dom/client';
import { Combobox } from './components/combobox/Combobox';

export const mount = (props) => {
    const container = document.getElementById(props.containerId);
    const root = createRoot(container);

    return root.render(<Combobox {...props} />);
}

export const asQueryParams = (suggestion) => {
    return `?prefix=${suggestion.properties.prefix || ''}&housenumber=${suggestion.properties.housenumber || ''}&street=${suggestion.properties.street}&suffix=${suggestion.properties.suffix || ''}&postcode=${suggestion.properties.postcode}&citycode=${suggestion.properties.citycode}&city=${suggestion.properties.city}`;
}

export {getCoords} from "./utils/map/geocodingUtils";